import React, { useEffect, useState } from 'react';
import { AppCard, AppRemixIcon, AppNoInfo } from '@/layout/AppComponents';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from "react-router-dom";
import { axiosPath } from '../../../../../../routing/helpers/router';
import Translator from '../../../../../components/helpers/Translator';
import colors from '../../../../../../constants/colors';
import minions from '../../../../../../minions/minions';

export default function GGCLLegalTab(props) {
  const { obligationID } = props;
  const { moduleBridgeHex, filtersHex } = useParams();
  const [legal, setLegal] = useState();
  const [selected, setSelected] = useState(null);

  // > LOAD INFORMATION TAB
  const loadLegalTab = async () => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_globalLegalCompliance_evaluation_tab_legal"
        ),
        {
          moduleBridgeHex,
          filtersHex,
          obligationID,
        }
      );
      return response.data;
    } catch (err) {}
  };
  useEffect(() => {
    loadLegalTab().then((r) => {
      setLegal(r);
    });
  }, []);
  // < LOAD INFORMATION TAB

  const handleDownloadFile = async (fileID, type) => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_globalLegalCompliance_evaluation_tab_legal_downloadLawFile"
        ),
        {
          // plantHex,
          fileID,
          type,
        }
      );
      window.open(response.data, "_blank");
      return response.data;
    } catch (err) {
      return console.log(err);
    }
  };

  if (!legal) return <AppNoInfo minHeight={300} />;

  return (
    <LegalTabContainer>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th className="col-lg-2">
                <Translator
                  file="user"
                  name="user.obligations.location.location"
                />
              </th>
              <th className="col-lg-4">
                <Translator
                  file="user"
                  name="user.obligations.location.article"
                />
              </th>
              <th className="col-lg-3">
                <Translator file="user" name="user.obligations.location.law" />
              </th>
              <th className="col-lg-3">
                <Translator
                  file="user"
                  name="user.obligations.location.modification"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {legal.map((row, i) => (
              <tr key={row.article.id}>
                <td>
                  <div>{row.location.name}</div>
                </td>
                <td
                  onClick={() =>
                    setSelected({
                      index: i,
                      text: row.article.modification,
                      modifications: row.article.modifications,
                      type: 'article',
                    })
                  }
                >
                  <div
                    className={
                      selected?.index === i && selected?.type === 'article'
                        ? 'selected'
                        : ''
                    }
                  >
                    {row.article.modifications?.length > 0 && (
                      <b>{`(${row.article.modifications?.[0]?.dateStamp}) `}</b>
                    )}
                    {row.article.name}
                  </div>
                </td>
                <td
                  onClick={() =>
                    setSelected({
                      index: i,
                      text: row.law.name,
                      type: 'law',
                      lawFiles: row.law.lawFiles,
                      lawModFiles: row.law.lawModFiles,
                      externalWebLink: row.law.externalWebLink,
                    })
                  }
                >
                  <div
                    className={
                      selected?.index === i && selected?.type === 'law'
                        ? 'selected'
                        : ''
                    }
                  >
                    {row.law.name}
                  </div>
                </td>
                <td
                  onClick={() =>
                    setSelected({
                      index: i,
                      text: row.lawModification.text,
                      type: 'lawModification',
                      externalWebLink: row.lawModification.externalWebLink,
                    })
                  }
                >
                  <div
                    className={
                      selected?.index === i &&
                      selected?.type === 'lawModification'
                        ? 'selected'
                        : ''
                    }
                    dangerouslySetInnerHTML={{
                      __html: row.lawModification.text,
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <AppCard>
        <SelectedText>
          {selected ? (
            <>
              {selected.modifications?.length > 0 && (
                <div className="font-weight-bold">
                  <Translator
                    file="module-legalCompliance"
                    name="latest.modification"
                  />
                  {`: ${selected.modifications?.[0]?.dateStamp}`}
                </div>
              )}
              <div dangerouslySetInnerHTML={{ __html: selected?.text }} />
              {selected?.type === 'lawModification' && <hr />}
              {selected?.externalWebLink && (
                <LawFileList>
                  <li
                    className="link pb-2"
                    onClick={() => window.open(selected?.externalWebLink?.url)}
                  >
                    <AppRemixIcon
                      icon="link"
                      color={colors.primaryLight}
                      noVariants
                    />
                    <span className="pl-2">
                      {selected?.externalWebLink?.name}
                    </span>
                  </li>
                </LawFileList>
              )}
              {selected.lawFiles && (
                <LawFileList>
                  {selected.lawFiles.map((lf) =>
                    lf?.files ? (
                      <li key={lf.id} className="pb-2" title={lf.fileName}>
                        {minions.files.fileIcon(lf.fileName)}{' '}
                        <span className="pl-2">{lf.name}</span>{' '}
                        {lf.files.map((af) => (
                          <React.Fragment key={af.id}>
                            |{' '}
                            <a
                              className="lang-link"
                              onClick={() =>
                                handleDownloadFile(af.id, 'lawFile')
                              }
                            >
                              {af.slug}
                            </a>{' '}
                          </React.Fragment>
                        ))}
                        {lf.files.length > 0 && <> |</>}
                      </li>
                    ) : (
                      <li
                        className="link pb-2"
                        key={lf.id}
                        title={lf.fileName}
                        onClick={() => handleDownloadFile(lf.id, 'lawFile')}
                      >
                        {minions.files.fileIcon(lf.fileName)}{' '}
                        <span className="pl-2">{lf.name}</span>
                      </li>
                    )
                  )}
                </LawFileList>
              )}
              <hr />
              {selected.lawModFiles && (
                <LawFileList>
                  {selected.lawModFiles.map((lf) =>
                    lf?.files ? (
                      <li key={lf.id} className="pb-2" title={lf.fileName}>
                        {minions.files.fileIcon(lf.fileName)}{' '}
                        <span className="pl-2">{lf.name}</span>{' '}
                        {lf.files.map((af) => (
                          <React.Fragment key={af.id}>
                            |{' '}
                            <a
                              className="lang-link"
                              onClick={() =>
                                handleDownloadFile(af.id, 'lawModificationFile')
                              }
                            >
                              {af.slug}
                            </a>{' '}
                          </React.Fragment>
                        ))}
                        {lf.files.length > 0 && <> |</>}
                      </li>
                    ) : (
                      <li
                        className="link pb-2"
                        key={lf.id}
                        title={lf.fileName}
                        onClick={() =>
                          handleDownloadFile(lf.id, 'lawModificationFile')
                        }
                      >
                        {minions.files.fileIcon(lf.fileName)}{' '}
                        <span className="pl-2">{lf.name}</span>
                      </li>
                    )
                  )}
                </LawFileList>
              )}
              {selected.modifications?.map((m, i) => (
                <div key={i}>
                  <span className="font-weight-bold">
                    <Translator
                      file="module-lawFinder"
                      name="module.lf.modificationStamp-short"
                    />
                    {` ${m.dateStamp}`}
                  </span>
                  <div
                    dangerouslySetInnerHTML={{ __html: m?.name }}
                    className="mb-2 pb-2 border-bottom"
                  />
                </div>
              ))}
            </>
          ) : (
            <AppNoInfo
              separation="0"
              text={
                <Translator file="general" name="select.option.from.list" />
              }
              icon={
                <AppRemixIcon
                  icon="auction"
                  color={colors.primaryLight}
                  size={30}
                />
              }
              color={colors.primaryLight}
            />
          )}
        </SelectedText>
      </AppCard>
    </LegalTabContainer>
  );
}

const LegalTabContainer = styled.div`
  height: 400px;
  .table-container {
    max-height: 196px;
    overflow-y: auto;
  }
  tr > td {
    padding: 4px;
    color: ${colors.primary};
    font-size: 12px;
    & > div {
      height: 20px;
      overflow-y: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
      &.selected {
        background: ${colors.grey400};
      }
    }
  }
`;

const SelectedText = styled.div`
  height: 150px;
  overflow-y: auto;
  border: 1px solid ${colors.grey300};
  border-radius: 2px;
  padding: 4px;
`;

const LawFileList = styled.ul`
  margin: 15px 0 0 10px;
  padding: 0;
  list-style: none;
  .lang-link {
    color: ${colors.primary};
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .link {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
`;
